import React from 'react'

function SuccessStoryPost() {
    return (
        <>
            <div className="flex flex-col px-5 relative">
                <img
                    loading="lazy"
                    srcSet="https://s3-alpha-sig.figma.com/img/639c/e213/d2b6a2997f43521764f46e21bec09901?Expires=1710720000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=CtfgoxiP-LHALAXGykDaDmfyVjZcgP0Lp~m2tWGoNJsjNMEHcKuTNHBf5~o8q-A7qNbGpFw6LkDD~f8YiWmN5uuxuEpvqay9bmZHwcwa4lo3~s7IkZu2pyR9jQeomsO5R0622twDDvLza4l-VVOLHAXJvHmcb0Aa-eU1kNdQt3V3fcVz3Cwip-iXXv6OPnNXlc8STL5P7PD13dnDMp27ZYL7zv5fy8XtxrwMqOQ4iqWsdIy0MLIqS2fC5lNP0WtJuqZ79fCSXQr8PdU0-FWpWs5Qg48e0cGEmJZJZHZGziwa7Vm0ovDIFb5oymN3m3Szzn5de-3w4L~RsQmBISPKww__"
                    className="w-full object-cover h-[462px] max-md:max-w-full relative"
                />
                <div className="relative bottom-20 flex z-10 flex-col self-center p-8 mt-0 w-full text-lg font-medium leading-7 text-right bg-white rounded-2xl max-w-[1200px] text-zinc-900 max-md:px-5 max-md:max-w-full">
                    <div className="text-5xl font-bold text-black max-md:max-w-full">
                        مساعدة الأطفال ذوي الاحتياجات الخاصة: كيف قامت منظمة غير ربحية بتوفير
                        تأهيل ودعم مستدام للأطفال المصابين بالتوحد
                    </div>
                    <div className="mt-8 max-md:max-w-full">
                        في فلسطين، تواجه السكان تحديات إنسانية كبيرة نتيجة الظروف السياسية
                        والاقتصادية الصعبة. يشمل ذلك صعوبة الوصول إلى الرعاية الصحية الأساسية
                        والتعليم، وارتفاع معدلات البطالة وصعوبة الحصول على السكن اللائق. إضافة
                        إلى ذلك، تأثرت البنية التحتية والمأوى بشكل كبير جراء النزاعات الدائرة.{" "}
                    </div>
                    <div className="mt-8 max-md:max-w-full">
                        تعتبر المساعدات الغذائية والدعم النفسي والاجتماعي أمورًا ضرورية للكثير
                        من الأسر. من المهم أن يستمر العمل على تلبية هذه الاحتياجات الإنسانية
                        وتقديم الدعم للسكان في فلسطين لتحسين جودة حياتهم وتعزيز الاستقرار في
                        المنطقة.
                    </div>
                    <div className="mt-5 max-md:max-w-full">
                        {" "}
                        يواجه السكان العديد من الاحتياجات الإنسانية بسبب الظروف الصعبة، بما في
                        ذلك نقص الرعاية الصحية، وصعوبة الوصول إلى الغذاء والتعليم، وقلة السكن
                        الملائم. النزاعات والصراعات تترك آثارًا نفسية واجتماعية، مما يجعل
                        الدعم النفسي والاجتماعي ضروريًا. تعمل المنظمات الإنسانية والدولية على
                        تقديم المساعدة للمجتمعات المتأثرة لمساعدتهم في تلبية هذه الاحتياجات
                        وتحسين جودة حياته
                    </div>
                    <div className="mt-5 max-md:max-w-full">
                        عاني السكان من نقص في الرعاية الصحية والوصول إلى الغذاء والتعليم،
                        وتواجه التحديات الاقتصادية والاجتماعية الصعبة. الصراعات والنزاعات تترك
                        آثارًا نفسية واجتماعية، مما يجعل الدعم النفسي والاجتماعي ضروريًا. تعمل
                        المنظمات الإنسانية والدولية على تقديم المساعدة للمجتمعات المتأثرة
                        لمساعدتهم في تلبية هذه الاحتياجات وتحسين جودة حياته
                    </div>
                    <div className="mt-5 max-md:max-w-full">
                        {" "}
                        يواجه السكان العديد من الاحتياجات الإنسانية بسبب الظروف الصعبة، بما في
                        ذلك نقص الرعاية الصحية، وصعوبة الوصول إلى الغذاء والتعليم، وقلة السكن
                        الملائم. النزاعات والصراعات تترك آثارًا نفسية واجتماعية، مما يجعل
                        الدعم النفسي والاجتماعي ضروريًا. تعمل المنظمات الإنسانية والدولية على
                        تقديم المساعدة للمجتمعات المتأثرة لمساعدتهم في تلبية هذه الاحتياجات
                        وتحسين جودة حياته
                    </div>
                    <div className="mt-5 max-md:max-w-full">
                        {" "}
                        يواجه السكان العديد من الاحتياجات الإنسانية بسبب الظروف الصعبة، بما في
                        ذلك نقص الرعاية الصحية، وصعوبة الوصول إلى الغذاء والتعليم، وقلة السكن
                        الملائم. النزاعات والصراعات تترك آثارًا نفسية واجتماعية، مما يجعل
                        الدعم النفسي والاجتماعي ضروريًا. تعمل المنظمات الإنسانية والدولية على
                        تقديم المساعدة للمجتمعات المتأثرة لمساعدتهم في تلبية هذه الاحتياجات
                        وتحسين جودة حياته
                    </div>
                </div>
                <div className="flex flex-col mt-44">
                    <div className="self-start text-3xl font-bold text-right whitespace-nowrap text-zinc-900">
                        صور خاصة بقصة النجاح
                    </div>
                    <div className=" mt-8 w-full max-md:max-w-full">
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
                            <div className="flex flex-col max-md:ml-0 max-md:w-full">
                                <div className="flex text-center overflow-hidden relative flex-col grow justify-center items-center px-16 pt-60 pb-4 text-2xl font-bold text-white whitespace-nowrap rounded-md aspect-[1.31] max-md:px-5 max-md:pt-10 max-md:mt-5">
                                    <img
                                        loading="lazy"
                                        srcSet="https://s3-alpha-sig.figma.com/img/4d17/c8c7/cdae31ec5f075ea3b45af4257bd267a3?Expires=1710720000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=oFZ70-KLz74sHIQWsscbmI1ENx3XU6ebgn7E3Mn6lOF7OpJRhOozIfAP8w51NQmny3Y71FibnMo4AJKyo0RfjGmBl11u9TS7bNxiEatXnBu8unxJCQFctRz02yGA5yGb5wb6txFSFVkQiWPhFozFSciwBcINVIYezXZuKbygOCzFpgLEYgp1~ljc0AB~mahywI9UvXpovL4dITPKVH~CcVilEeYmjsnEIvPYQwFnXnby06ty~nqir9SPnO4VqXcrR2F0y9Z4lEKDap827~HubQYI~GmLpimY07OgJ2oJ~CX2-WU1Xx6wsbnSXmdN9SVdKTu97Ul~evQ-pdTddDDgMw__"
                                        className="object-cover absolute inset-0 w-full h-full"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-50"></div>

                                    <span className='absolute '>بناء مساجد</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SuccessStoryPost